import React from 'react';
import HorizontalCardIcon from './HorizontalCardIcon';

export default Icon => {
  return class HorizontalCardIconFactory extends React.Component {
    render() {
      return (
        <HorizontalCardIcon icon={<Icon card={this.props.card} />}>
          {this.props.card.title}
        </HorizontalCardIcon>
      );
    }
  };
};
